const TNWS_INFO_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-tnws-info" viewBox="0 0 18 18"><circle cx="9" cy="9" r="6.5" stroke="currentColor" stroke-width="1.35"/><path stroke="currentColor" stroke-width="1.35" stroke-linecap="round" d="M9 8.1V12.6"/><circle cx="9" cy="5.85" r="0.55" fill="currentColor"/></svg>`;

function tnwsCloseAddonInfoWrap(wrap) {
  if (!wrap) return;
  wrap.classList.remove('is-open');
  wrap.querySelector('[data-tnws-addon-info]')?.setAttribute('aria-expanded', 'false');
}

function tnwsCloseAllAddonInfo(exceptWrap) {
  document.querySelectorAll('.tnws-product-addon__info-wrap.is-open').forEach((wrap) => {
    if (wrap !== exceptWrap) tnwsCloseAddonInfoWrap(wrap);
  });
}

function tnwsOpenAddonInfoWrap(wrap) {
  if (!wrap) return;
  tnwsClearAddonInfoCloseTimer(wrap);
  tnwsCloseAllAddonInfo(wrap);
  wrap.classList.add('is-open');
  wrap.querySelector('[data-tnws-addon-info]')?.setAttribute('aria-expanded', 'true');
  tnwsPositionAddonInfoPopup(wrap);
}

function tnwsPositionAddonInfoPopup(wrap) {
  const popup = wrap.querySelector('.tnws-product-addon__info-popup');
  if (!popup) return;

  const edge = 12;
  popup.style.setProperty('--tnws-popup-shift', '0px');
  wrap.classList.remove('is-below');

  const header = document.querySelector('.section-header');
  const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
  if (popup.getBoundingClientRect().top < headerBottom + edge) wrap.classList.add('is-below');

  const rect = popup.getBoundingClientRect();
  const viewportWidth = document.documentElement.clientWidth;
  let shift = 0;
  if (rect.left < edge) shift = edge - rect.left;
  else if (rect.right > viewportWidth - edge) shift = viewportWidth - edge - rect.right;
  popup.style.setProperty('--tnws-popup-shift', `${Math.round(shift)}px`);
}

const tnwsAddonInfoCloseTimers = new WeakMap();

function tnwsClearAddonInfoCloseTimer(wrap) {
  const timer = tnwsAddonInfoCloseTimers.get(wrap);
  if (!timer) return;
  clearTimeout(timer);
  tnwsAddonInfoCloseTimers.delete(wrap);
}

function tnwsClearAllAddonInfoCloseTimers() {
  document.querySelectorAll('.tnws-product-addon__info-wrap').forEach((wrap) => {
    tnwsClearAddonInfoCloseTimer(wrap);
  });
}

function tnwsScheduleAddonInfoClose(wrap) {
  if (!wrap) return;
  tnwsClearAddonInfoCloseTimer(wrap);
  tnwsAddonInfoCloseTimers.set(
    wrap,
    setTimeout(() => {
      tnwsCloseAddonInfoWrap(wrap);
      tnwsAddonInfoCloseTimers.delete(wrap);
    }, 150)
  );
}

function tnwsBindInfoIcons() {
  if (window.__tnwsAddonInfoBound) return;
  window.__tnwsAddonInfoBound = true;

  document.addEventListener('mouseover', (event) => {
    const wrap = event.target.closest('.tnws-product-addon__info-wrap');
    if (!wrap) return;

    tnwsClearAddonInfoCloseTimer(wrap);

    if (!wrap.contains(event.relatedTarget)) {
      tnwsOpenAddonInfoWrap(wrap);
    }
  });

  document.addEventListener('mouseout', (event) => {
    const wrap = event.target.closest('.tnws-product-addon__info-wrap');
    if (!wrap || wrap.contains(event.relatedTarget)) return;
    tnwsScheduleAddonInfoClose(wrap);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tnws-addon-info]');
    if (button) {
      event.preventDefault();
      const wrap = button.closest('.tnws-product-addon__info-wrap');
      if (!wrap.classList.contains('is-open')) tnwsOpenAddonInfoWrap(wrap);
      return;
    }

    if (!event.target.closest('.tnws-product-addon__info-wrap')) {
      tnwsClearAllAddonInfoCloseTimers();
      tnwsCloseAllAddonInfo();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      tnwsClearAllAddonInfoCloseTimers();
      tnwsCloseAllAddonInfo();
    }
  });
}

function tnwsIsConditionListItem(li) {
  return /\bcondition\s*:/i.test(li.textContent.trim());
}

function tnwsConditionPopupHtml(popupId) {
  return `
    <span id="${popupId}" class="tnws-product-addon__info-popup tnws-product-addon__info-popup--wide tnws-condition-info-popup" role="tooltip">
      <span class="tnws-product-addon__info-popup-headline">Know the condition:</span>
      <span class="tnws-product-addon__info-popup-body">
        <ul class="tnws-condition-grades">
          <li class="tnws-condition-grade tnws-condition-grade--new">
            <span class="tnws-condition-grade__name">New Stock</span>
            <span class="tnws-condition-grade__desc">New, never worn</span>
          </li>
          <li class="tnws-condition-grade tnws-condition-grade--excellent">
            <span class="tnws-condition-grade__name">Excellent Refurbished</span>
            <span class="tnws-condition-grade__desc">Refurbished like new, no significant cosmetic issues</span>
          </li>
          <li class="tnws-condition-grade tnws-condition-grade--good">
            <span class="tnws-condition-grade__name">Good Refurbished</span>
            <span class="tnws-condition-grade__desc">Some minor cosmetic issues like scratches or wear</span>
          </li>
          <li class="tnws-condition-grade tnws-condition-grade--fair">
            <span class="tnws-condition-grade__name">Fair Refurbished</span>
            <span class="tnws-condition-grade__desc">Obvious cosmetic issues</span>
          </li>
        </ul>
        <div class="tnws-condition-guarantee">
          <p class="tnws-condition-guarantee__note">All watches come fully functioning.</p>
          <p class="tnws-condition-guarantee__text">That's a This Nice Watch Shop guarantee.</p>
        </div>
        <a class="tnws-condition-info-link" href="${(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/')}pages/condition-grades">What the grades mean <span aria-hidden="true">&rarr;</span></a>
      </span>
    </span>
  `;
}

function tnwsInsertConditionInfoIcon(li) {
  const popupId = `tnws-condition-info-${Math.random().toString(36).slice(2, 9)}`;
  const wrap = document.createElement('span');
  wrap.className = 'tnws-product-addon__info-wrap tnws-spec-info-wrap';
  wrap.innerHTML = `
    <button
      type="button"
      class="tnws-product-addon__info focus-none tnws-spec-info"
      aria-describedby="${popupId}"
      aria-expanded="false"
      data-tnws-addon-info
    >
      <span class="svg-wrapper">${TNWS_INFO_ICON_SVG}</span>
      <span class="visually-hidden">More information</span>
    </button>
    ${tnwsConditionPopupHtml(popupId)}
  `;

  const conditionLabel = Array.from(li.querySelectorAll('strong')).find((el) =>
    /condition/i.test(el.textContent)
  );

  if (conditionLabel) {
    conditionLabel.after(wrap);
  } else {
    li.prepend(wrap);
  }
}

function tnwsFormatSpecifications(specList) {
  const items = Array.from(specList.querySelectorAll(':scope > li'));
  const conditionLi = items.find(tnwsIsConditionListItem);
  if (!conditionLi) return;

  specList.insertBefore(conditionLi, specList.firstElementChild);

  if (!conditionLi.querySelector('[data-tnws-addon-info]')) {
    tnwsInsertConditionInfoIcon(conditionLi);
  }
}

function tnwsFormatProductDescription(desc) {
  if (!desc || desc.dataset.tnwsFormatted === 'true') return;
  desc.dataset.tnwsFormatted = 'true';

  let child = desc.firstElementChild;
  while (child) {
    const tag = child.tagName;
    const text = child.textContent.trim();

    if (/^H[1-6]$/.test(tag)) {
      const next = child.nextElementSibling;
      child.remove();
      child = next;
      continue;
    }

    if (
      tag === 'P' &&
      (/^watch$/i.test(text) ||
        (child.querySelector('strong') && text.length < 120 && !text.includes('.')))
    ) {
      const next = child.nextElementSibling;
      child.remove();
      child = next;
      continue;
    }

    break;
  }

  const descParagraph = desc.querySelector(':scope > p');
  if (descParagraph && !desc.querySelector('.tnws-product-desc-label--description')) {
    const descriptionLabel = document.createElement('p');
    descriptionLabel.className = 'tnws-product-desc-label tnws-product-desc-label--description';
    descriptionLabel.textContent = 'Description:';
    descParagraph.before(descriptionLabel);
  }

  const specList =
    Array.from(desc.querySelectorAll(':scope > ul')).find((ul) =>
      Array.from(ul.querySelectorAll(':scope > li')).some(tnwsIsConditionListItem)
    ) || desc.querySelector(':scope > ul');

  if (specList && !desc.querySelector('.tnws-product-desc-label--specifications')) {
    const specificationsLabel = document.createElement('p');
    specificationsLabel.className = 'tnws-product-desc-label tnws-product-desc-label--specifications';
    specificationsLabel.textContent = 'Specifications:';
    specList.before(specificationsLabel);
  }

  if (specList) {
    tnwsFormatSpecifications(specList);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  tnwsBindInfoIcons();
  document.querySelectorAll('.product__description.rte').forEach(tnwsFormatProductDescription);
});
